var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.90039C15 11.6451 10.8457 15.5451 9.45075 16.7496C9.32079 16.8474 9.1626 16.9002 9 16.9002C8.8374 16.9002 8.67921 16.8474 8.54925 16.7496C7.15425 15.5451 3 11.6451 3 7.90039C3 6.30909 3.63214 4.78297 4.75736 3.65775C5.88258 2.53253 7.4087 1.90039 9 1.90039C10.5913 1.90039 12.1174 2.53253 13.2426 3.65775C14.3679 4.78297 15 6.30909 15 7.90039Z",
    stroke: "#99A1AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10.1504C10.2426 10.1504 11.25 9.14303 11.25 7.90039C11.25 6.65775 10.2426 5.65039 9 5.65039C7.75736 5.65039 6.75 6.65775 6.75 7.90039C6.75 9.14303 7.75736 10.1504 9 10.1504Z",
    stroke: "#99A1AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.72a5769e663b28aea034b31e1b275ea6.svg";
export { ForwardRef as ReactComponent };